import { Route, Routes } from 'react-router-dom';
import { ReactFlowProvider } from 'reactflow';

import { GoogleOAuthProvider } from '@react-oauth/google';

import { Modal } from '@components/modal';
import { RouteErrorBoundary } from '@components/route-error-boundary';
import { Sidebar } from '@components/sidebar';
import { Toaster } from '@components/toaster';

import { getRoutePaths, RouteMapper } from 'ui/helpers';

import { AuthenticationPageContainer } from './pages/common';
import { routes } from './routes';

export const routePaths = getRoutePaths([{ routes, prefix: '' }]);

export const UnauthenticatedNavigation = () => (
  <GoogleOAuthProvider clientId="657878040280-4j7a15rjjgt7rja55u7ckc126rqrnpbg.apps.googleusercontent.com">
    <ReactFlowProvider>
      <Toaster />
      <Sidebar.Provider />
      <Modal.Provider />
      <Routes>
        <Route
          path="*"
          element={
            <AuthenticationPageContainer>
              <RouteMapper routes={routes} defaultRoute={routePaths.signin} />
            </AuthenticationPageContainer>
          }
          errorElement={<RouteErrorBoundary />}
        />
      </Routes>
    </ReactFlowProvider>
  </GoogleOAuthProvider>
);
